import { Button } from "@sellar-io/components";
import { zLayer } from "@sellar-io/components";
import { useLayoutEffect, useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { getServiceWorker } from "../../utils/browserCapabilities";

//check every two hours
const intervalMS = 2 * 60 * 60 * 1000;
const bannerHeight = "60px";

export const RefreshPwaBanner = () =>
  getServiceWorker() ? <SupportedRefreshPwaBanner /> : null;

const SupportedRefreshPwaBanner = () => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW: (swUrl, r) => {
      if (r) {
        setInterval(async () => {
          if (r.installing || !navigator.onLine) return;
          try {
            const resp = await fetch(swUrl, {
              cache: "no-store",
              headers: {
                cache: "no-store",
                "cache-control": "no-cache",
              },
            });

            if (resp.status === 200) await r.update();
          } catch {
            // Keep the current app usable when a background update is unavailable.
          }
        }, intervalMS);
      }
    },
    onRegisterError(error) {
      console.log("SW registration error", error);
    },
  });

  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    if (!needRefresh) return;

    document.documentElement.style.setProperty(
      "--refresh-pwa-banner-height",
      bannerHeight,
    );

    return () => {
      document.documentElement.style.removeProperty(
        "--refresh-pwa-banner-height",
      );
    };
  }, [needRefresh]);

  if (!needRefresh) return null;

  return (
    <>
      {/* In-flow spacer: flex parent subtracts this from remaining height (see App shell). */}
      <div
        aria-hidden="true"
        style={{ height: bannerHeight }}
        className="col-span-full w-full shrink-0"
      />
      <div
        style={{ height: bannerHeight }}
        className={`fixed top-0 right-0 left-0 ${zLayer.banner} flex shrink-0 items-center justify-between bg-purple-600 px-6`}
      >
        <span className={"text-sm font-bold text-white"}>
          A new version of Sellar is available
        </span>
        <div
          className={"flex cursor-pointer items-center gap-4 text-sm uppercase"}
        >
          <Button
            size={"small"}
            color={"secondary"}
            className={"text-purple-600"}
            disabled={!needRefresh}
            loading={loading}
            onClick={() => {
              setLoading(true);
              void updateServiceWorker(true)
                .then(() => setNeedRefresh(false))
                .catch(() => {
                  // Keep the update action available for another attempt.
                })
                .finally(() => setLoading(false));
            }}
          >
            Update
          </Button>
        </div>
      </div>
    </>
  );
};
